import { render } from "./NewContact.vue?vue&type=template&id=476b9d7a&ts=true"
import script from "./NewContact.vue?vue&type=script&lang=ts"
export * from "./NewContact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__